import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as CONSTS from "../../assets/consts";
import ProfileModel from "../viewModels/Profile";
import BuildingInfo from "../viewModels/BuildingInfo";
import { IS_WEB } from "../locales/translate";
import ServerInfo from "../viewModels/ServerInfo";
import checkIPAddress from "../hooks/checkIPAddress";
function generateAccessTokenKeyByBuildingId(buildingId: string) {
  return `${CONSTS.ACCESS_TOKEN}_${buildingId}`;
}

export async function getItemAsync(key = ""): Promise<string | null> {
  if (key) {
    try {
      // if (Platform.OS === "android" || Platform.OS === "ios") {
      //   return await AsyncStorage.getItem(key);
      // } else {
      return await AsyncStorage.getItem(key);
      // }
    } catch (error: any) {
      if (error.toString().indexOf("Could not decrypt") >= 0) {
        await deleteItemAsync(key);
        return null;
      }
    }
  }
  return null;
}

export async function setItemAsync(key = "", value = "") {
  if (key) {
    // if (Platform.OS === "android" || Platform.OS === "ios") {
    //   const checkSecureActive = await setSecureLocalStorageMode();
    //   console.log("checkSecureActive", checkSecureActive);
    //   await AsyncStorage.setItem(key, value);
    // } else {
    await AsyncStorage.setItem(key, value);
    // }
  }
}
export async function deleteItemAsync(key: string) {
  if (key) {
    // if (Platform.OS === "android" || Platform.OS === "ios") {
    //   await AsyncStorage.removeItem(key);
    // } else {
    await AsyncStorage.removeItem(key);
    // }
  }
}
// export async function setSecureLocalStorageMode() {
//   SecureStore.setItemAsync(CONSTS.CHECK_SECURE_STORAGE, CONSTS.TRUE)
//     .catch(() => {
//       return Promise.reject(true);
//     })
//     .catch(() => {
//       return Promise.reject(false);
//     });
// }
// export async function getSecureLocalStorageMode() {
//   SecureStore.getItemAsync(CONSTS.CHECK_SECURE_STORAGE)
//     .then(() => {
//       return true;
//     })
//     .catch(() => {
//       return false;
//     });
// }

export async function setAccessToken(
  buildingId: string,
  accessToken: string | undefined
) {
  if (accessToken) {
    // store as old way for backward compatibility
    await setItemAsync(CONSTS.ACCESS_TOKEN, accessToken);
    if (buildingId) {
      var key = generateAccessTokenKeyByBuildingId(buildingId);
      await setItemAsync(key, accessToken);
    }
  }
}

export async function getAccessToken(buildingId: string) {
  var key = CONSTS.ACCESS_TOKEN;
  if (buildingId) {
    key = generateAccessTokenKeyByBuildingId(buildingId);
    // console.log("try get token with key",key);
  }
  var token = await getItemAsync(key);
  if (!token) {
    // console.log("token not found with key", key);
  }
  return token;
}

export async function deleteAccessToken(buildingId: string) {
  var key = generateAccessTokenKeyByBuildingId(buildingId);
  await deleteItemAsync(key);
}

export async function getServerUrl() {
  var serverURL = await getItemAsync(CONSTS.SERVER_URL);
  if (serverURL != null) {
    if (!serverURL?.endsWith("/")) {
      return serverURL?.concat("/");
    }
  }
  return serverURL;
}

export async function getProfilesList(): Promise<ProfileModel[]> {
  try {
    //await migrateProfileList();
    var profilesJson = await AsyncStorage.getItem(CONSTS.PROFILES_LIST);
    var profiles = JSON.parse(profilesJson || "[]");
    if (Array.isArray(profiles)) {
      // console.log('profiles', profiles)
      return profiles;
    }
  } catch (error) {
    console.log("error on DeviceAsyncStorage.getProfilesList", error);
  }
  return [];
}

export function getDefaultProfile() {
  var modelDefault = new ProfileModel(
    "",
    "",
    CONSTS.BRANDING.CLOUD_SERVER,
    "",
    "",
    "",
    true
  );
  modelDefault.id = "bms";
  // console.log("modelDefault", modelDefault);
  return modelDefault;
}

export async function setProfilesList(profiles: ProfileModel[] = []) {
  await AsyncStorage.setItem(CONSTS.PROFILES_LIST, JSON.stringify(profiles));
}

export async function getActiveProfile(getFirstIfNotAvailable = false) {
  try {
    var profiles = await getProfilesList();
    var profile = profiles.filter((p) => p.isActive)[0];
    if (profile) {
      var model = new ProfileModel();
      Object.assign(model, profile);
      var accessToken = await getAccessToken(model.id);
      if (accessToken) {
        model.accessToken = accessToken;
      }
      return model;
    } else if (getFirstIfNotAvailable && profiles.length) {
      profiles[0].isActive = true;
      setItemAsync(CONSTS.PROFILES_LIST, JSON.stringify(profiles));
      var model = new ProfileModel();
      Object.assign(model, profiles[0]);
      var accessToken = await getAccessToken(model.id);
      if (accessToken) {
        model.accessToken = accessToken;
      }
      // console.log("ActiveProfile", model);
      return model;
    } else if (getFirstIfNotAvailable) {
      var defaultProfile = getDefaultProfile();
      await setProfilesList([defaultProfile]);
      return defaultProfile;
    }
    return null;
  } catch (e) {
    console.log("error on DeviceAsyncStorage.getActiveProfile", e);
    return null;
  }
}

export async function migrateTokens() {
  try {
    var profilesJson = await getItemAsync(CONSTS.PROFILES_LIST);
    var profiles = JSON.parse(profilesJson || "[]");
    if (profiles) {
      var modified = false;
      for (let i = 0; i < profiles.length; i++) {
        var profile = profiles[i];
        let { id, accessToken } = profile;
        if (accessToken) {
          await setAccessToken(id, accessToken);
          delete profile.accessToken;
          modified = true;
        }
      }

      if (modified) {
        await setItemAsync(CONSTS.PROFILES_LIST, JSON.stringify(profiles));
      }
    }
  } catch (error) {
    console.log("error on DeviceAsyncStorage.migrateTokens()", error);
  }
}

export async function migrateProfileList() {
  if (Platform.OS === "android" || Platform.OS === "ios") {
    try {
      var profilesJson = await getItemAsync(CONSTS.PROFILES_LIST);
      if (profilesJson) {
        console.log("move profiles from secure store to async storage");
        await AsyncStorage.setItem(CONSTS.PROFILES_LIST, profilesJson);
        await AsyncStorage.removeItem(CONSTS.PROFILES_LIST);
      }
    } catch (e) {
      console.log(`error on migrateProfileList`, e);
    }
  }
}

export async function getBuildingId() {
  var buildingId = await getItemAsync(CONSTS.BUILDING_ID);
  return buildingId;
}

export async function setBuildingId(buildingId = "") {
  await setItemAsync(CONSTS.BUILDING_ID, buildingId);
}

// === Server ===
export const Servers = {
  addServer: async (serverInfo: ServerInfo) => {
    let servers = await Servers.getServers();
    if (Array.isArray(servers)) {
      const someServerInfo = servers.find(
        (server) => server.serverId == serverInfo.serverId
      );
      var defaultServerInfo = servers.find(
        (server) => server.serverId == "defaultServer"
      );
      if (
        (serverInfo?.publicAddress && serverInfo?.publicAddress?.endsWith("/")
          ? serverInfo?.publicAddress == CONSTS.BRANDING.CLOUD_SERVER + "/"
          : serverInfo?.publicAddress == CONSTS.BRANDING.CLOUD_SERVER) &&
        defaultServerInfo
      ) {
        servers[servers.indexOf(defaultServerInfo)] = serverInfo;
      } else if (someServerInfo) {
        servers[servers.indexOf(someServerInfo)] = serverInfo;
      } else {
        servers.push(serverInfo);
      }
    }
    await Servers.setServers(servers);
  },
  removeServer: async (serverId: string) => {
    var servers = await Servers.getServers();
    if (Array.isArray(servers)) {
      servers = servers.filter((server) => server.serverId != serverId);
    }
    Servers.setServers(servers);
  },
  updateServer: async (serverInfo: ServerInfo) => {
    var servers = await Servers.getServers();
    if (Array.isArray(servers)) {
      var someServerInfo = servers.find(
        (server) => server.serverId == serverInfo.serverId
      );
      var defaultServerInfo = servers.find(
        (server) => server.serverId == "defaultServer"
      );
      if (
        serverInfo?.publicAddress && serverInfo?.publicAddress.endsWith("/")
          ? serverInfo.publicAddress == CONSTS.BRANDING.CLOUD_SERVER + "/"
          : serverInfo.publicAddress == CONSTS.BRANDING.CLOUD_SERVER
      ) {
        defaultServerInfo.serverId = serverInfo.serverId;
        defaultServerInfo.publicAddress = serverInfo.publicAddress;
        defaultServerInfo.accessToken = serverInfo.accessToken;
        defaultServerInfo.userFullName = serverInfo.userFullName;
        defaultServerInfo.userId = serverInfo.userId;
        servers[servers.indexOf(defaultServerInfo)] = defaultServerInfo;
      } else if (someServerInfo) {
        someServerInfo.publicAddress = serverInfo.publicAddress;
        someServerInfo.accessToken = serverInfo.accessToken;
        someServerInfo.userFullName = serverInfo.userFullName;
        someServerInfo.userId = serverInfo.userId;
        servers[servers.indexOf(someServerInfo)] = someServerInfo;
      }
    }
    Servers.setServers(servers);
  },
  getServers: async () => {
    var serversJson = (await getItemAsync(CONSTS.SERVER_LIST)) || "[]";
    var servers = JSON.parse(serversJson);
    var defaultServer = Servers.getDefaultServer();
    let checkDefaultAddress = true;
    if (!IS_WEB) {
      checkDefaultAddress = servers.find((server: ServerInfo) => {
        if (server?.publicAddress) {
          return server?.publicAddress.endsWith("/")
            ? server?.publicAddress == defaultServer.publicAddress + "/"
            : server?.publicAddress == defaultServer.publicAddress;
        }
      });
      // return false;
    }
    var isDefaultServer = servers.find(
      (server: ServerInfo) => server.serverId == defaultServer.serverId
    );
    if (!isDefaultServer && !checkDefaultAddress) {
      servers.push(defaultServer);
    }
    return servers;

    // var serversJson = (await getItemAsync(CONSTS.SERVER_LIST)) || "[]";
    // const servers = JSON.parse(serversJson);
    // return servers;
  },
  findServer: async (serverId: string) => {
    const servers = await Servers.getServers();
    const server: ServerInfo = servers.find(
      (server: ServerInfo) => server.serverId === serverId
    );
    return server;
  },
  setServers: async (servers: ServerInfo[]) => {
    var _servers = servers;
    _servers = _servers.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.serverId === elem.serverId;
        }) === index
    );
    const serversInfoString = JSON.stringify(_servers);
    await setItemAsync(CONSTS.SERVER_LIST, serversInfoString);
  },
  getCurrentServer: async (serverId = null) => {
    const serverUrlStorage = await getServerUrl();
    let currentBuilding: BuildingInfo | null =
      await Buildings.getCurrentBuilding();
    const accessToken = await getItemAsync(CONSTS.ACCESS_TOKEN);
    var servers = await Servers.getServers();
    const defaultServer = Servers.getDefaultServer();
    if (currentBuilding) {
      const serverInfo: ServerInfo | null = servers.find(
        (server: ServerInfo) => {
          if (serverUrlStorage && checkIPAddress(serverUrlStorage)) {
            return server.serverId == currentBuilding?.serverId;
          } else if (currentBuilding?.cloudServerId) {
            return server.serverId == currentBuilding?.cloudServerId;
          } else {
            return server.serverId == currentBuilding?.serverId;
          }
          // server.serverId == currentBuilding?.cloudServerId
        }
      );
      if (serverInfo) {
        return serverInfo;
      }
      return defaultServer;
    } else if (accessToken) {
      const currentServer = servers.find(
        (server: ServerInfo) => server.accessToken == accessToken
      );
      return currentServer || null;
    } else if (serverId) {
      const currentServer = servers.find(
        (server: ServerInfo) => server.serverId == serverId
      );
      return currentServer || defaultServer;
    } else {
      return defaultServer;
    }
  },
  clearToken: async (serverId: string) => {
    var servers = await Servers.getServers();
    // === find cloudServerId from buildings ===
    var buildings: BuildingInfo[] = await Buildings.findBuildingsWithServerId(
      serverId
    );
    if (buildings && servers) {
      servers.forEach((elementServer: ServerInfo) => {
        buildings.forEach((elementBuilding: BuildingInfo) => {
          if (
            elementServer.serverId === elementBuilding.serverId ||
            elementServer.serverId === elementBuilding.cloudServerId
          ) {
            elementServer.accessToken = "";
            servers[servers.indexOf(elementServer)] = elementServer;
          }
        });
      });
    }
    Servers.setServers(servers);
  },
  getAccessToken: async (serverId: string) => {
    const server = await Servers.findServer(serverId);
    if (server && server?.accessToken !== "") {
      return server?.accessToken;
    }
    return null;
  },
  getDefaultServer: () => {
    var modelDefault = new ServerInfo(
      "defaultServer",
      CONSTS.BRANDING?.CLOUD_SERVER,
      null,
      "",
      "",
      "",
      CONSTS.DEFAULT_PORTS_BRAND
    );
    // console.log("modelDefault", modelDefault);
    return modelDefault;
  },
};
// === Building ===
export const Buildings = {
  addBuilding: async (buildingInfo: BuildingInfo) => {
    var buildings = await Buildings.getBuildings();
    if (Array.isArray(buildings)) {
      const someBuildingInfo = buildings.find(
        (building) => building.buildingId == buildingInfo.buildingId
      );
      if (someBuildingInfo) {
        buildings[buildings.indexOf(someBuildingInfo)] = buildingInfo;
      } else {
        buildings.push(buildingInfo);
      }
    }
    await Buildings.setBuildings(buildings);
  },
  addBuildings: async (buildingsInfo: BuildingInfo[] | []) => {
    // var buildings = await Buildings.getBuildings();
    // const _serverId = buildingsInfo[0]?.serverId;
    var _buildings: BuildingInfo[] = buildingsInfo;
    _buildings = _buildings.filter(
      (elem, index, self) =>
        self.findIndex((t) => {
          return t?.buildingId === elem?.buildingId;
        }) === index
    );
    // === Delete building for empty list ===
    // if (buildingsInfo.length === 0) {
    //   const currentServer = await Servers.getCurrentServer();
    //   const buildingFiltered = buildings.filter((building: BuildingInfo) => {
    //     if (
    //       building?.serverId === currentServer?.serverId ||
    //       building?.cloudServerId === currentServer?.serverId
    //     ) {
    //       return building;
    //     }
    //   });
    //   if (buildingFiltered.length !== 0) {
    //     const filterBuildingList = buildings.filter(
    //       (building: BuildingInfo) =>
    //         building.buildingId !== buildingFiltered[0].buildingId
    //     );
    //     if (filterBuildingList.length !== 0) {
    //       _buildings = filterBuildingList;
    //     }
    //   }
    // }
    await Buildings.setBuildings(_buildings);
  },
  removeBuilding: async (buildingId: string) => {
    var buildings = await Buildings.getBuildings();
    if (Array.isArray(buildings)) {
      buildings.filter((building) => building.buildingId != buildingId);
    }
    await Buildings.setBuildings(buildings);
  },
  removeBuildingByServerId: async (serverId?: string) => {
    if (serverId) {
      var buildings = await Buildings.getBuildings();
      buildings = buildings.filter((building: BuildingInfo) => {
        return (
          building.serverId !== serverId && building.cloudServerId !== serverId
        );
      });
      await Buildings.setBuildings(buildings);
    } else {
      await deleteItemAsync(CONSTS.BUILDINGS);
    }
  },
  updateBuilding: async (buildingInfo: BuildingInfo) => {
    var buildings = await Buildings.getBuildings();
    if (Array.isArray(buildings)) {
      const someBuildingInfo = buildings.find(
        (building) => building.buildingId == buildingInfo.buildingId
      );
      if (someBuildingInfo) {
        buildings[buildings.indexOf(someBuildingInfo)] = buildingInfo;
      }
    }
    Buildings.setBuildings(buildings);
  },
  getBuildings: async () => {
    var buildingsJson = await getItemAsync(CONSTS.BUILDINGS);
    const buildings = JSON.parse(buildingsJson || "[]");
    return buildings;
  },
  setBuildings: async (buildings: BuildingInfo[]) => {
    const buildingsInfoString = JSON.stringify(buildings);
    await setItemAsync(CONSTS.BUILDINGS, buildingsInfoString);
  },
  findBuilding: async (buildingId: string) => {
    const buildings = await Buildings.getBuildings();
    const building = buildings.find(
      (building: BuildingInfo) => building.buildingId === buildingId
    );
    return building;
  },
  findBuildingsWithServerId: async (serverId: string) => {
    const buildings = await Buildings.getBuildings();
    const building = buildings.map((building: BuildingInfo) => {
      return (
        (building?.serverId === serverId ||
          building?.cloudServerId === serverId) &&
        building
      );
    });
    return building;
  },
  getCurrentBuilding: async () => {
    let buildingId = await getBuildingId();
    if (buildingId) {
      const buildingList = await Buildings.getBuildings();
      const currentBuilding = buildingList.find(
        (building: BuildingInfo) => building.buildingId == buildingId
      );
      return currentBuilding;
    }
    return null;
  },
};

// === migration count ===
export const setMigrationVersion = async (version = "1") => {
  const getVersion = await getItemAsync(CONSTS.MIGRATION_VERSION);
  if (!getVersion) {
    await setItemAsync(CONSTS.MIGRATION_VERSION, version);
    return Number(version);
  }
  return Number(getVersion);
};
export const getMigrationVersion = async () => {
  const getVersion = await getItemAsync(CONSTS.MIGRATION_VERSION);
  return getVersion;
};
